<template>
    <div class="cardComponente d-flex flex-column align-items-center" :class="classeStatus.corStatus">
        <div class="cardHeader d-flex flex-column justify-content-center align-items-center">
            <p>{{ textoHeader }}</p>
        </div>
        <div class="cardBody d-flex flex-column justify-content-center align-items-center text-center">
            <div ref="chartDom" style="width: 100%; height: 100%;"></div>
        </div>
        <p class="footerText">{{ textoFooter }}</p>
    </div>
</template>

<script>
	import * as echarts from "echarts";

	export default {
		name: "CardGrafico",
		props: {
			textoCard: { type: Number },
			textoHeader: { type: String },
			textoFooter: { type: String },
			textoCardClass: { type: String },
			classeStatus: {
				type: Object,
				required: true
			}
		},
		data () {
			return {
				chartInstance: null,
				isAtivo: false, // Controla se o componente está ativo na tela
				precisaAtualizar: false // Avisa se os dados mudaram enquanto estava escondido
			};
		},
		watch: {
			textoCard:{

				handler () {
					// Se o componente estiver escondido no keep-alive, não atualiza o gráfico na hora
					if (!this.isAtivo) {
						this.precisaAtualizar = true; // Deixa o aviso salvo para quando voltar
						return;
					}

					// Se estiver ativo, atualiza o gráfico imediatamente
					this.atualizarGrafico(this.textoHeader, this.textoCard, this.classeStatus.corGrafico);
				}

			}
		},
		mounted () {
			this.isAtivo = true;
			this.$nextTick(() => {
				this.initChart();
			});
			window.addEventListener("resize", this.resizeChart);
		},
		activated () {
			this.isAtivo = true;

			this.$nextTick(() => {
				if (!this.chartInstance) {
					this.initChart();
				} else {
					this.chartInstance.resize();

					// Quando o usuário volta para a aba, verificamos se a variável mudou enquanto ele estava fora
					if (this.precisaAtualizar) {
						this.atualizarGrafico(this.textoHeader, this.textoCard, this.classeStatus.corGrafico);
						this.precisaAtualizar = false; // Reseta o aviso
					}
				}
			});
		},
		deactivated () {
			this.isAtivo = false;
		},
		beforeDestroy () {
			window.removeEventListener("resize", this.resizeChart);
			if (this.chartInstance) {
				this.chartInstance.dispose();
				this.chartInstance = null;
			}
		},
		methods: {
			initChart () {
				const dom = this.$refs.chartDom;
				if (!dom || dom.clientWidth === 0 || dom.clientHeight === 0) return;

				this.chartInstance = echarts.init(dom);

				// Primeira renderização
				this.atualizarGrafico(this.textoHeader, this.textoCard, this.classeStatus.corGrafico);
			},

			atualizarGrafico (texto, valor, cor) {
				if (!this.chartInstance) return;

				const option = {
					grid: {
						left: "",
						right: "18%",
						bottom: "",
						top: "15%",
						containLabel: true
					},
					xAxis: {
						type: "category",
						data: [texto],
						axisLine: { show: true, lineStyle: { color: "#999" } },
						axisTick: { show: false },
						axisLabel: { fontSize: "8", color: "#666", fontWeight: "bold" }
					},
					yAxis: {
						type: "value",
						min: 0,
						max: 100,
						interval: 20,
						axisLabel: {
							color: "#999",
							fontSize: "8",
							fontWeight: "bold"
						},
						splitLine: {
							lineStyle: {
								type: "dashed",
								color: "#E0E0E0"
							}
						}
					},
					series: [
						{
							data: [valor],
							type: "bar",
							barWidth: "40%",
							showBackground: true,
							backgroundStyle: {
								color: "rgba(180, 180, 180, 0.1)"
							},
							itemStyle: {
								color: cor,
								borderRadius: [2, 2, 0, 0]
							},
							label: {
								show: true,
								position: "top",
								distance: 2,
								formatter: "{c}%",
								fontWeight: "bold",
								color: "#333",
								fontSize: 8
							}
						}
					]
				};

				this.chartInstance.setOption(option);
			},

			resizeChart () {
				if (this.chartInstance && this.$refs.chartDom.clientWidth > 0) {
					this.chartInstance.resize();
				}
			}
		}
	};
</script>

<style scoped>
.cardComponente {
    height: 173px;
    width: 260px;
    background-color: var(--bg-primario);
    border-radius: 16px;
    border: 2px solid var(--cor-erro);

}

.cardHeader {
    background-color: var(--cor-erro);
    height: 25%;
    width: 100%;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    color: var(--bg-primario);
    padding-top: 15px;
}


.cardBody {
    width: 150px;
    height: 100px;
    gap: 0.5em;
    padding: 0.7em;
    font-size: 13px;
    margin-top: auto;
}

.footerText {
    font-size: 9px;
    align-self: center;
    margin-top: auto;
}

p {
    font-family: var(--fonte-semi-bold);
    white-space: pre-line;
}

.card-status-erro {
    border: 2px solid var(--cor-erro);
}

.card-status-erro .cardHeader {
    background-color: var(--cor-erro);
}

.card-status-ok {
    border: 2px solid var(--cor-ok);
}

.card-status-ok .cardHeader {
    background-color: var(--cor-ok);
}

.card-status-alert {
    border: 2px solid var(--cor-alert);

}

.card-status-alert .cardHeader {
    background-color: var(--cor-alert);

}
</style>